// extracted by mini-css-extract-plugin
export var completionBody = "_mk-2";
export var completionCard = "_mk-0";
export var completionFooter = "_mk-3";
export var completionTitle = "_mk-1";